<ng-container *ngIf="!isServer">
  <a [routerLink]="['/hostel', hostel._id]" [queryParams]="searchParams | async" queryParamsHandling="merge" aria-hidden="true" tabindex="-1"></a>
</ng-container>
<div class="image" [ngClass]="{'loaded': loaded}">
  <div class="hostel-btns">
    <div class="hostel-btns-left">
      <div class="btn-card" *ngIf="hostel.overallRating">
        <svg-icon style="height: 16px" [svgStyle]="{'width.px': 16, 'height.px': 15.3}" src="../../assets/icons/star-white.svg"></svg-icon>
        <span>
            {{ hostel.overallRating | number : '1.0-2' }}
        </span>
      </div>
      <div class="btn-card" *ngIf="hostel.propertyRecommendationCount">
        <svg-icon style="height: 16px" [svgStyle]="{'width.px': 16, 'height.px': 16}" src="../../assets/icons/thumb-white.svg"></svg-icon>
        <span>
          {{ hostel.propertyRecommendationCount }}
        </span>
      </div>
    </div>
    <div class="hostel-btns-right">
      <div class="btn icon-btn">
        <!-- <svg-icon style="height: 17.5px" [svgStyle]="{'width.px': 20, 'height.px': 17.5}" src="../../assets/icons/heart_full.svg"></svg-icon> -->
      </div>
    </div>
  </div>
  <ng-container *ngIf="i === 0">
    <ng-container *ngIf="isServer; else lazyBrowserTpl">
      <a href="[[SSR_DATA_HOSTEL_LINK]]" tabindex="-1">
        <img
          src="https://storage.hostelhop.io/images/resize/[[SSR_DATA_IMAGE_MAIN]]?width=420"
          fetchPriority="high"
          #img
          alt="">
      </a>
    </ng-container>
    <ng-template #lazyBrowserTpl>
      <a [routerLink]="['/hostels', hostel._id]" [queryParams]="searchParams | async" queryParamsHandling="merge" aria-hidden="true" tabindex="-1">
        <img ngOptimizedImage [ngSrc]="hostel.propertyImages?.[0]?.fileName!" [alt]="hostel.name" [fill]="true" #img ngSrcset="350w" sizes="350w" [priority]="true" />
      </a>
    </ng-template>
  </ng-container>
  <ng-container *ngIf="i !== undefined && i > 0">
    <ng-container *ngIf="hostel.propertyImages?.[0] as image">
      <a [routerLink]="['/hostels', hostel._id]" [queryParams]="searchParams | async" queryParamsHandling="merge" aria-hidden="true" tabindex="-1">
        <img ngOptimizedImage [ngSrc]="image.fileName" [alt]="hostel.name" [fill]="true" #img ngSrcset="350w" sizes="350w"/>
      </a>
    </ng-container>
    <div class="scroll-left"></div>
    <div class="scroll-right"></div>
    <div class="circles">
      <!-- <div class="inner">
        <svg xmlns="http://www.w3.org/2000/svg" width="60" height="6" viewBox="0 0 60 6" fill="none">
          <circle cx="3" cy="3" r="3" fill="white"/>
          <circle cx="17.25" cy="3" r="2.25" stroke="white" stroke-width="1.5"/>
          <circle cx="30.75" cy="3" r="2.25" stroke="white" stroke-width="1.5"/>
          <circle cx="44.25" cy="3" r="2.25" stroke="white" stroke-width="1.5"/>
          <circle cx="57.75" cy="3" r="1.5" stroke="white" stroke-width="1.5"/>
        </svg>
      </div> -->
    </div>
  </ng-container>
  <ng-container *ngIf="!hostel.propertyImages?.[0]">
    <img />
  </ng-container>
</div>
<div class="info">
  <p class="info-row">
    <span class="title">
      <ng-container *ngIf="i === 0">
        <ng-container *ngIf="isServer; else lazyBrowserTpl">
          [[SSR_DATA_HOSTEL_NAME]]
        </ng-container>
        <ng-template #lazyBrowserTpl>
          {{ hostel.name }}
        </ng-template>
      </ng-container>
      <ng-container *ngIf="i > 0">
        <ng-container *ngIf="(hostel$ | async)">
          {{ hostel.name }}
        </ng-container>
        <ng-container *ngIf="!(hostel$ | async)">
          <div class="info-row-inner"></div>
        </ng-container>
      </ng-container>
    </span>
  </p>
  <p class="info-row light">
    <!-- todo ssr_data_hostel_location here -->
    <ng-container *ngIf="(hostel$ | async)">
      <span>{{ hostel.address?.city }}</span>, <span>{{ hostel.address?.country }}</span>
    </ng-container>
    <ng-container *ngIf="!(hostel$ | async)">
      <div class="info-row-inner"></div>
    </ng-container>
    <ng-container *ngIf="showLocation">
      <span>
        <svg-icon [svgStyle]="{'width.px': 20, 'height.px': 20}" src="../../assets/icons/marker.svg"></svg-icon> {{ distance }} <ng-container i18n>km away</ng-container>
      </span>
    </ng-container>
  </p>
  <p class="info-row">
    <ng-container *ngIf="(hostel$ | async) as h">
      <ng-container *ngIf="h.minRate">
        <ng-container i18n>Dorms from</ng-container> <span class="rate-value">&nbsp;{{ h.minRate | currency : currency!.code : 'symbol' : '1.0-0' }}</span>
        <span *ngIf="h.privateMinRate">&nbsp;&bull;&nbsp;</span>
      </ng-container>
      <ng-container *ngIf="h.privateMinRate">
        <ng-container i18n>Privates from</ng-container> <span class="rate-value">&nbsp;{{ h.privateMinRate | currency : currency!.code : 'symbol' : '1.0-0' }}</span>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="!(hostel$ | async)">
      <div class="info-row-inner"></div>
    </ng-container>
  </p>
</div>
